<template lang="html">
  <div class="mdl-layout__header-row">
    <nav class="mdl-navigation fixed-navbar">
      <a class="mdl-navigation__link" href="/">Home map</a>
      <a class="mdl-navigation__link" href="#map">View map</a>
      <a class="mdl-navigation__link" href="#blog">Blog</a>
      <a class="mdl-navigation__link" href="#">About</a>
      <a class="mdl-navigation__link" href="#">Contact</a>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'navbar'
}
</script>

<style lang="scss">

.fixed-navbar {
  position: fixed
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue